import * as React from "react";

import { default as Slider } from "antd/lib/slider";
import Accordion from "react-bootstrap/Accordion";
import "bootstrap/dist/css/bootstrap.min.css";

import CheckBox from "../Checkbox/Checkbox";


export const FilterBox = (props: any) => {
    let filter_label = window.Configs.filters[props.filter_key]['name'];

    return (
        <>
            {props.type == "checkbox" && (
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey={"filter-" + filter_label}>
                        <Accordion.Header
                            className={props.first ? "first-acc-header" : "filter-title"}
                        >
                            <h6>{filter_label}</h6>
                        </Accordion.Header>
                        <Accordion.Body className="acc-scroll">
                            {Object.keys(props.data).map((filter_value) => (
                                <div key={"wrapper-" + filter_value}>
                                    <div
                                        key={"filter-" + filter_value}
                                        id={filter_label + "-" + filter_value}
                                        className={"filter float-left"}
                                    >
                                        <CheckBox
                                            name={filter_value}
                                            key={filter_value}
                                            value={filter_value}
                                            label={filter_value}
                                            checked={props.state[filter_value]}
                                            onChange={props.handler}
                                        />
                                    </div>
                                    <div
                                        key={"count-" + filter_value}
                                        className="float-right qty-display"
                                    >
                                        {
                                            props.count != undefined &&
                                            props.count.hasOwnProperty(filter_value) &&
                                            (
                                                props.count[filter_value]
                                            )
                                        }
                                        {
                                            props.count != undefined &&
                                            !props.count.hasOwnProperty(filter_value) &&
                                            (
                                                0
                                            )
                                        }
                                    </div>
                                    <div
                                        key={filter_value}
                                        className="float-clear"
                                    ></div>
                                </div>
                            ))}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}

            {props.type == "range" && (
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey={"filter-" + filter_label}>
                        <Accordion.Header
                            className={
                                props.first
                                    ? "first-acc-header"
                                    : "filter-title"
                            }
                        >
                            <h6>{filter_label}</h6>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <p className="float-left">
                                    {props.state[0].toFixed(
                                        props.data.decimal
                                    ) + props.data.unit}
                                </p>
                                <p className="float-right">
                                    {props.state[1].toFixed(
                                        props.data.decimal
                                    ) + props.data.unit}
                                </p>
                                <Slider
                                    id="reach-slider"
                                    className="float-clear"
                                    range
                                    onChange={props.handler}
                                    min={props.data.min}
                                    max={props.data.max}
                                    defaultValue={[
                                        props.data.min,
                                        props.data.max,
                                    ]}
                                    step={props.data.step}
                                    value={[props.state[0], props.state[1]]}
                                />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )}
        </>
    );
};
